import { createReducer } from '@reduxjs/toolkit'

import { INotifiesState } from '../types'
import * as actions from '../actions'

const initialState: INotifiesState['data'] = {
  firstDeposit: {
    item: null,
    isShowed: false,
  },
  cashback: {
    all: [],
    hide: [],
  },
  personalJackpot: {
    all: [],
    hide: [],
  },
}

export default createReducer(initialState, builder => {
  builder
    .addCase(actions.getFirstDeposit.success, (state, action) => {
      state.firstDeposit.item = action.payload.history.length ? action.payload.history[0] : null
    })
    .addCase(actions.hideFirstDepositNotify, state => {
      state.firstDeposit.isShowed = true
    })
    .addCase(actions.getCashbackList.success, (state, action) => {
      state.cashback.all = action.payload.history
    })
    .addCase(actions.hideCashbackNotify, (state, action) => {
      state.cashback.hide = [...state.cashback.hide, action.payload]
    })
    .addCase(actions.getPersonalJackpots.success, (state, action) => {
      state.personalJackpot.all = action.payload.history
    })
    .addCase(actions.hidePersonalJackpotNotify, (state, action) => {
      state.personalJackpot.hide = [...state.personalJackpot.hide, action.payload]
    })
})
